// extracted by mini-css-extract-plugin
module.exports = {"forum-entry":"CommunityEntry_forum-entry__GNDgK"};